import Immutable from 'immutable';
import * as ActionTypes from 'constants/ActionTypes';
import * as Graphdata from 'constants/Graphdata';

let initialState = Immutable.fromJS({
  // Set overviewChart default view to week
  OverviewChart: {
    selection: Graphdata.SELECTION_INTRADAY,
  },
});

export default function overviewChart(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.GRAPHDATA_RECEIVE_BUCKET:
      return state.mergeIn(
        [action.componentId, 'buckets', action.bucketId],
        action.data,
      );
    case ActionTypes.GRAPHDATA_SET_ITEM:
      return state.setIn([action.componentId, 'itemSector'], action.itemSector);

    case ActionTypes.GRAPHDATA_REQUEST_DATA:
      return state.setIn([action.componentId, 'isFetching'], true);

    case ActionTypes.GRAPHDATA_SETUP_COMPONENT:
      return state.setIn(
        [action.componentId],
        Immutable.fromJS({
          isFetching: true,
          selection: Graphdata.SELECTION_INTRADAY,
          itemSector: action.itemSector,
          buckets: {},
        }),
      );

    case ActionTypes.GRAPHDATA_CLEAR_BUCKETS:
      return state.setIn([action.componentId, 'buckets'], Immutable.fromJS({}));

    case ActionTypes.GRAPHDATA_CREATE_BUCKET:
      return state.setIn(
        [action.componentId, 'buckets', action.bucketId],
        Immutable.fromJS({ series: [], isFetching: true }),
      );

    case ActionTypes.GRAPHDATA_RECEIVE_SERIES:
      state = state.setIn([action.componentId, 'isFetching'], false);
      return state.setIn(
        [action.componentId, 'buckets', action.bucketId, 'series'],
        action.data,
      );

    case ActionTypes.GRAPHDATA_SET_SELECTION:
      return state.setIn([action.componentId, 'selection'], action.selection);

    case ActionTypes.GRAPHDATA_ADD_BUCKET_WITH_SERIES:
      state = state.setIn(
        [action.componentId, 'buckets', action.bucketId],
        action.data,
      );
      const isFetching = state
        .getIn([action.componentId, 'buckets'])
        .filter(val => val.get('isFetching'));

      return state.setIn(
        [action.componentId, 'isFetching'],
        isFetching.size !== 0,
      );

    default:
      return state;
  }
}

/*

graphdataStore = {
  'someComponentId': {
    isFetching: true,
    selection: 'WEEK',
    item: { ... },
    buckets: {
      '2015-11-09': {
        isFetching: false,
        open: '2015-11-09T09:00:00.000+01:00',
        close: '2015-11-09T16:30:00.000+01:00',
        series: [{
          cols: ['TIME', 'LAST'],
          data: [[ts, val]],
        }],
      }
      '2015-11-06': {
        isFetching: false,
        open: '2015-11-06T09:00:00.000+01:00',
        close: '2015-11-06T16:30:00.000+01:00',
        series: [{
          cols: ['TIME', 'LAST'],
          data: [[ts, val]],
        }],
      },
      '2015-11-05': {
        isFetching: true,
        open: '2015-11-05T09:00:00.000+01:00',
        close: '2015-11-05T16:30:00.000+01:00',
        series: [],
      }
    }
  },
  'someOtherComponentId': {
    // ...
  }
}

// {
//   'OSEBX.OSE': {
//     isFetching: true,
//     buckets: {
//       'day': {
//         isFetching: false,
//         cols: ['TIME', 'LAST'],
//         data: [[ts, val]],
//       },
//     }
//   }
// }

*/
